// Styles
import styles from "./Stars.module.css";

// Icons
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarRateIcon from "@mui/icons-material/StarRate";

const Stars = ({ fillCount }) => {
  // round fillCount to nearest [0.5] value
  const rating = Math.round(fillCount * 2) / 2;

  // Render a div containing 5 stars
  return (
    <div className={styles.review_card_stars}>
      {/* Create an array of 5 elements and map over them */}
      {Array.from({ length: 5 }, (_, index) => {
        const diff = rating - index;

        // Render stars based on fill value (diff)
        return diff >= 1 ? (
          <StarRateIcon
            fontSize="small"
            className={styles.review_card_star__filled}
            key={`star-${index}`}
          />
        ) : diff >= 0.3 ? (
          <StarHalfIcon
            fontSize="small"
            className={styles.review_card_star__filled}
            key={`star-${index}`}
          />
        ) : (
          <StarOutlineIcon
            fontSize="small"
            className={styles.review_card_star__empty}
            key={`star-${index}`}
          />
        );
      })}
    </div>
  );
};

export default Stars;
